import { cmToFeetAndInches, cmToMeters } from './MeasurementUnits';
import { kilosToPounds } from './WeightConversions';

export const formatWeightValueForDisplay = (
  numberValue: number | string | null | undefined,
  isMetric: boolean,
) => {
  if (numberValue === null || numberValue === undefined) return '';

  const numericalValue =
    typeof numberValue === 'string' ? parseFloat(numberValue) : numberValue;

  if (isNaN(numericalValue)) return '';

  if (isMetric) {
    return Math.round(numericalValue).toFixed();
  } else {
    return Math.round(kilosToPounds(numericalValue)).toFixed();
  }
};

export const formatDimensionValueForDisplay = (
  numberValue: number | undefined | null | string,
  isMetric: boolean,
) => {
  if (numberValue === null || numberValue === undefined) return '';
  const numericalValue =
    typeof numberValue === 'string' ? parseFloat(numberValue) : numberValue;
  if (isMetric) {
    return cmToMeters(numericalValue);
  } else {
    return cmToFeetAndInches(numericalValue);
  }
};
